export default __webpack_public_path__ + "static/media/rtist-logo.d5f87884.png";